@if (displayHeader) {
  <h1 class="mb-3">Создание юридического лица</h1>
}
@if (form && nalogForms) {
  <app-entity-create-fields [forms]="forms" [form]="form" [types]="types" (dataChange)="data = $event"></app-entity-create-fields>
  @if (form.value.organisation_type_id !== '4') {
    <app-entity-additionally-fields [nalogForms]="nalogForms" [form]="form.controls['requisites']" (postDataChange)="entityRequisitesData = $event"></app-entity-additionally-fields>
  }
}
<div class="row no-gutters gutters-2 mt-3">
  <div class="col-8">
    <button type="submit" (click)="onSubmit()" class="button" [disabled]="!form.valid">Сохранить и закрыть</button>
  </div>
  <div class="col-4 text-right">
    <button type="button" class="button button_sm" (click)="onCancelClick()">Отмена</button>
  </div>
</div>

